import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Node } from 'src/io/models/node'
import { ReplaySubject } from 'rxjs'
import { map, filter } from 'rxjs/operators'
import { getAnalytics } from 'src/app/libs/collections/functions/analytics'
import { trackById } from '../../../../shared/utility-functions/track-by-id.utility'

export type NodeListWidgetComponentProps = {
  nodes: ReadonlyArray<
    Pick<
      Node,
      'asset' | 'title' | 'publish_start_date' | 'publish_end_date' | 'short_title' | 'id' | 'slug_uri' | 'slug'
    >
  >
  headerTitle?: string
  limit?: number
}

@Component({
  selector: 'flo-node-list-widget',
  templateUrl: './node-list-widget.component.html',
  styleUrls: ['./node-list-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeListWidgetComponent {
  public props$ = new ReplaySubject<NodeListWidgetComponentProps>(1)

  @Input()
  set props(props: NodeListWidgetComponentProps) {
    if (props) {
      this.props$.next(props)
    }
  }

  public nodes$ = this.props$.pipe(
    filter(props => !!props.nodes.length),
    map(props =>
      props.nodes
        .filter((nodes, i) => (!!props.limit ? i < props.limit : i < 5))
        .map((node, i, arr) => ({
          ...node,
          analytics: { ...getAnalytics(node as Node, i, arr.length), component: 'NodeListWidgetComponent' }
        }))
    )
  )

  public headerTitle$ = this.props$.pipe(map(props => props.headerTitle || 'Related Content'))

  public trackById = trackById
}
